import { getPagesInCampaign } from "../widgets/PageList";
import { getSessionToken } from "@/api/auth";

import { useState } from "react";

import TemplateSelectionGroup from "@/Apps/Pages/Properties/components/sections/Appearance";

import { updateCampaign } from "@/api/campaigns";
import { FormFieldTypes } from "@/Apps/CRM/types";
import { defaultColorPalettes } from "@/Apps/Pages/Properties/components/sections/Appearance/Appearance";
import { getCatalogItems } from "@/api/catalog";
import { updatePage } from "@/api/pages";

import {
  BorderShadow,
  ButtonSliderGroup,
  Typography,
  UploadGroup,
  Width,
  WidthHeight,
} from "@/Apps/Pages/Properties";
import SectionWrapper from "@/Apps/Pages/Properties/components/sections/SectionWrapper";
import { TextPromptGroup } from "@/Apps/Pages/Properties/components/groups/TextPromptGroup/TextPromptGroup";
import { ButtonExpansionGroup } from "@/Apps/Pages/Properties/components/groups/ButtonExpansionGroup/ButtonExpansionGroup";
import TabsComponent from "@/ui/TabsComponent";
import { TabTypes } from "@/ui/TabsComponent/types";
import Calout from "@/ui/Calout";
import { Minus, Plus } from "@phosphor-icons/react";
import Shadow from "@/Apps/Pages/Properties/Sections/BorderShadow/Shadow";
import {
  convertFromRem,
  convertToRem,
} from "@/Apps/Pages/MobileResponsiveToggle/style";

const templateType = "wireframes";
const templateCategory = "home";

export const getVariableValue = (variables, id, role = null, key = null) => {
  // const variables = campaignData?.settings?.variables || [];
  const variable = variables?.find((v) => v.id === id);
  if (key) return variable?.value?.[role]?.[key];
  if (role) return variable?.value?.[role];
  return variable?.value;
};

export const LiquidProperties = ({
  campaignData = {},
  setCampaignData = () => {},
  setIsLoading = () => {},
  setContent = (content: any) => {},
  isExpanded = false,
}) => {
  // const [isChecked, setIsChecked] = useState(true);
  const [isLogoExpanded, setIsLogoExpanded] = useState(isExpanded);
  const [typographyTab, setTypographyTab] = useState("headline");
  const [spacingTab, setSpacingTab] = useState("md");
  const [elevationTab, setElevationTab] = useState("level2");
  const [layoutTab, setLayoutTab] = useState("md");

  const applyTheme = async (id, content) => {
    setContent(content);

    const templates = await getCatalogItems({
      type: templateType,
      category: templateCategory,
    });

    console.log("all templates", templates);

    // 2. [ ] Loop through each campaign object
    const pageObjects = await getPagesInCampaign(campaignData);
    console.log("getPagesInCampaign", pageObjects);

    if (!pageObjects?.length) return;

    setIsLoading(true);

    for (const pageObject of pageObjects) {
      // 3. [ ] In each object, retrieve the page's content & type
      const pageContent = pageObject?.page?.content;
      const pageType = pageObject?.page?.type;

      // 4. [ ] Retrieve the templates for the theme group chosen
      const template = templates
        .filter((template) => template.tags === id)
        .find((template) => template.categories === pageType);

      // 5. [ ] Now retrieve the page content for the template that matches the page type
      const templatePageContent = template?.page?.content;

      // 6. [ ] Do a deep comparison between the template content and the page's content
      // Compare template content with page content
      const isContentMatching =
        JSON.stringify(templatePageContent) === JSON.stringify(pageContent);
      console.log("Content matching:", isContentMatching, {
        templatePageContent,
        pageContent,
      });

      // 7. [ ] If it doesn't match, update the page's content with the template's content
      if (!isContentMatching && templatePageContent) {
        // Update local state if this is the currently displayed page

        // setContent(content);

        // 8. [ ] Save the changes
        // Update the page content with template content
        const token = getSessionToken();
        await updatePage(pageObject.page.id, {
          token,
          content: templatePageContent,
        });
      }
    }

    setIsLoading(false);
  };

  const handleThemeChange = async (id, content) => {
    // 1. [ ] When theme is changed, inform the user that it will be applied to all unedited pages.
    const toContinue = window.confirm(
      "Changing the theme will update all unedited pages in this funnel. Do you want to continue?"
    );
    if (!toContinue) return;

    const newSettings = {
      settings: {
        ...campaignData?.settings,
        variables: [
          ...(campaignData?.settings?.variables || []).filter(
            (v) => v.id !== "themeId"
          ),
          {
            id: "themeId",
            label: "Theme",
            value: id,
            fieldType: FormFieldTypes.DROPDOWN,
          },
        ],
      },
    };

    setCampaignData({ ...campaignData, ...newSettings });

    const token = getSessionToken();
    const response = await updateCampaign(campaignData?.id, {
      token,
      settings: newSettings,
    });

    console.log("handleThemeChange", response);

    applyTheme(id, content);
  };

  const handleColorChange = async (id, valueOverride) => {
    const colorPalettes = [
      ...defaultColorPalettes.filter((itm) => itm.id !== "custom"),
      {
        id: "custom",
        label: "Custom",
        values: valueOverride,
      },
    ];

    const newSettings = {
      settings: {
        ...campaignData?.settings,
        variables: [
          ...(campaignData?.settings?.variables || []).filter(
            (v) => v.id !== "colors" && v.id !== "color" && v.id !== "palette"
          ),
          {
            id: "color",
            label: "Colors",
            value: colorPalettes.find((itm) => itm.id === id)?.values,
            fieldType: FormFieldTypes.TEXT,
          },
          {
            id: "palette",
            label: "Color Palette",
            value: colorPalettes.find((itm) => itm.id === id)?.id,
            fieldType: FormFieldTypes.DROPDOWN,
          },
        ],
      },
    };

    console.log({ newSettings });

    setCampaignData({ ...campaignData, ...newSettings });

    const token = getSessionToken();
    const response = await updateCampaign(campaignData?.id, {
      token,
      settings: newSettings,
    });

    console.log("handleColorChange", response);
  };

  const handleLogoChange = async (url) => {
    console.log("url", url);

    const newSettings = {
      settings: {
        ...campaignData?.settings,
        variables: [
          ...(campaignData?.settings?.variables || []).filter(
            (v) => v.id !== "logo"
          ),
          {
            id: "logo",
            label: "Logo",
            value: url,
            fieldType: FormFieldTypes.TEXT,
          },
        ],
      },
    };

    setCampaignData({ ...campaignData, ...newSettings });

    const token = getSessionToken();

    const response = await updateCampaign(campaignData?.id, {
      token,
      settings: newSettings,
    });

    console.log("handleLogoChange", response);
  };

  const handleCompanyNameChange = async (companyName) => {
    const newSettings = {
      settings: {
        ...campaignData?.settings,
        variables: [
          ...(campaignData?.settings?.variables || []).filter(
            (v) => v.id !== "companyName"
          ),
          {
            id: "companyName",
            label: "Company Name",
            value: companyName,
            fieldType: FormFieldTypes.TEXT,
          },
        ],
      },
    };

    setCampaignData({ ...campaignData, ...newSettings });

    if (campaignData?.id) {
      const token = getSessionToken();

      const response = await updateCampaign(campaignData?.id, {
        token,
        settings: newSettings,
      });

      console.log("handleCompanyNameChange", response);
    }
  };

  // const handleTypographyChange = async (id, tab, variant, style) => {
  //   console.log("handleTypographyChange", id, tab, variant, style);
  //   console.log(`{{ ${id}.${tab}${variant} }}`, style);
  //   const newSettings = {
  //     settings: {
  //       ...campaignData?.settings,
  //       variables: [
  //         ...(campaignData?.settings?.variables || []).filter(
  //           (v) => v.id !== "typography"
  //         ),
  //         {
  //           id: "typography",
  //           label: "Typography",
  //           value: {
  //             ...(campaignData?.settings?.variables?.find(
  //               (v) => v.id === "typography"
  //             )?.value || {}),
  //             [`${tab}${variant}`]: {
  //               ...(campaignData?.settings?.variables?.find(
  //                 (v) => v.id === "typography"
  //               )?.value?.[`${tab}${variant}`] || {}),
  //               ...style,
  //             },
  //           },
  //           fieldType: FormFieldTypes.TEXT,
  //         },
  //       ],
  //     },
  //   };

  //   setCampaignData({ ...campaignData, ...newSettings });

  //   const token = getSessionToken();
  //   const response = await updateCampaign(campaignData?.id, {
  //     token,
  //     settings: newSettings,
  //   });

  //   console.log("handleTypographyChange", response);
  // };

  const handleTypefaceChange = async (id, role, style) => {
    console.log("handleTypefaceChange", id, role, style);
    console.log(`{{ ${id}.${role} }}`, style?.fontFamily);

    const variables = campaignData?.settings?.variables || [];

    const currentTypeface = getVariableValue(variables, "typeface", role);
    console.log("currentTypeface", currentTypeface);
    const roleGroup = role === "display" ? {
      display: style.fontFamily,
      headline: style.fontFamily,
      title: style.fontFamily,
    } : {
      body: style.fontFamily,
      label: style.fontFamily,
    };

    const newSettings = {
      settings: {
        ...campaignData?.settings,
        variables: [
          ...(variables || []).filter((v) => v.id !== "typeface"),
          {
            id: "typeface",
            label: "Typeface",
            value: {
              ...(variables?.find((v) => v.id === "typeface")?.value || {}),
              ...roleGroup,
            },
            fieldType: FormFieldTypes.TEXT,
          },
        ],
      },
    };

    setCampaignData({ ...campaignData, ...newSettings });

    const token = getSessionToken();
    const response = await updateCampaign(campaignData?.id, {
      token,
      settings: newSettings,
    });

    console.log("handleTypefaceChange", response);
  };

  const handleSpacingChange = async (id, tab, value) => {
    const variables = campaignData?.settings?.variables || [];
    console.log("handleSpacingChange", id, tab, value);
    console.log(`{{ ${id}.${tab} }}`, value);

    const newSettings = {
      settings: {
        ...campaignData?.settings,
        variables: [
          ...variables.filter((v) => v.id !== "spacing"),
          {
            id: "spacing",
            label: "Spacing",
            value: {
              ...(variables?.find((v) => v.id === "spacing")?.value || {}),
              [tab]: value,
            },
            fieldType: FormFieldTypes.TEXT,
          },
        ],
      },
    };

    setCampaignData({ ...campaignData, ...newSettings });

    const token = getSessionToken();
    const response = await updateCampaign(campaignData?.id, {
      token,
      settings: newSettings,
    });

    console.log("handleSpacingChange", response);
  };

  const handleWidthChange = async (id, type, value) => {
    const variables = campaignData?.settings?.variables || [];
    console.log("handleWidthChange", id, type, value);
    console.log(`{{ ${id}.${type} }}`, value);

    const newSettings = {
      settings: {
        ...campaignData?.settings,
        variables: [
          ...variables.filter((v) => v.id !== "layout"),
          {
            id: "layout",
            label: "Layout",
            value: {
              ...(variables?.find((v) => v.id === "layout")?.value || {}),
              [type]: value || "100%",
            },
            fieldType: FormFieldTypes.TEXT,
          },
        ],
      },
    };

    setCampaignData({ ...campaignData, ...newSettings });

    const token = getSessionToken();
    const response = await updateCampaign(campaignData?.id, {
      token,
      settings: newSettings,
    });

    console.log("handleWidthChange", response);
  };  

  const variables = campaignData?.settings?.variables || [];

  return (
    <>
      {/* <SwitchGroup
        label="Enable this page"
        isChecked={isChecked}
        onClick={() => setIsChecked(!isChecked)}
        className="p-5"
      >
        <p>Display this page or hide it and redirect to your website.</p>
      </SwitchGroup> */}

      {/* About You */}
      <SectionWrapper label="About You" isExpanded={isExpanded}>
        <TextPromptGroup
          label="Company Name"
          value={
            // campaignData?.settings?.variables?.find((v) => v.id === "companyName")?.value
            getVariableValue(variables, "companyName")
          }
          onChange={handleCompanyNameChange}
        />

        <ButtonExpansionGroup
          label="Your Logo"
          value="Upload Logo"
          isExpanded={isLogoExpanded}
          onClick={() => {
            setIsLogoExpanded(!isLogoExpanded);
          }}
        >
          <UploadGroup
            sectionWrap={false}
            createMediaItem={() => {}}
            uploadURLToS3={() => {}}
            settings={{}}
            url={
              campaignData?.settings?.variables?.find((v) => v.id === "logo")
                ?.value || ""
            }
            accept="image/jpeg, image/png"
            highlighted
            onChange={(files: any[]) => handleLogoChange(files?.[0]?.preview)}
            isExpanded
            label="Logo"
          />
        </ButtonExpansionGroup>
      </SectionWrapper>

      {/* Template */}
      <div data-testid="TemplateSelectionGroup">
        <TemplateSelectionGroup
          type={templateType}
          isExpanded={isExpanded}
          filter={{ category: templateCategory }}
          payload={variables || []}
          onThemeChange={handleThemeChange}
          onColorChange={handleColorChange}
        />
      </div>

      {/* Typography */}
      <SectionWrapper
        label="Typeface"
        isExpanded={false}
        className="flex flex-col gap-4"
      >
        <div className="flex flex-col gap-4">
          {/* <TabsComponent
          tabs={[
            // { label: "All", value: "all" },
            { label: "Headlines", value: "headline" },
            { label: "Titles", value: "title" },
            { label: "Display", value: "display" },
            { label: "Body", value: "body" },
            { label: "Labels", value: "label" },
          ]}
          activeTab={typographyTab}
          setActiveTab={setTypographyTab}
          actionSection={false}
          className="p-0 transform scale-95"
          // type={TabTypes.BUTTON}
        /> */}

          {/* {typographyTab === "all" && (
          <Calout title="This will overwrite all typography settings." />
        )} */}

          {/* <Typography
          showColors={false}
          caption={<div className="pb-3">Large Variant</div>}
          hideLabel
          settings={{
            id: "typography",
            properties: {
              fontFamily: "Roboto",
              fontSize: "16px",
              color: "#000000",
              ...(campaignData?.settings?.variables?.find((v) => v.id === "typography")?.value?.[`${typographyTab}Large`] || {}),
            },
          }}
          updateComponentStyle={(id, style) =>
            handleTypographyChange(id, typographyTab, "Large", style)
          }
        />
        <Typography
          showColors={false}
          caption={<div className="pb-3">Medium Variant</div>}
          hideLabel
          settings={{
            id: "typography",
            properties: {
              fontFamily: "Roboto",
              fontSize: "16px",
              color: "#000000",
              ...(campaignData?.settings?.variables?.find((v) => v.id === "typography")?.value?.[`${typographyTab}Medium`] || {}),
            },
          }}
          updateComponentStyle={(id, style) =>
            handleTypographyChange(id, typographyTab, "Medium", style)
          }
        />
        <Typography
          showColors={false}
          caption={<div className="pb-3">Small Variant</div>}
          hideLabel
          settings={{
            id: "typography",
            properties: {
              fontFamily: "Roboto",
              fontSize: "16px",
              color: "#000000",
              ...(campaignData?.settings?.variables?.find((v) => v.id === "typography")?.value?.[`${typographyTab}Small`] || {}),
            },
          }}
          updateComponentStyle={(id, style) =>
            handleTypographyChange(id, typographyTab, "Small", style)
          }
        /> */}

          <Typography
            showColors={false}
            showFontSize={false}
            caption={<div className="pb-3">Display, Headlines, & Titles</div>}
            hideLabel
            settings={{
              id: "typeface",
              properties: {
                fontFamily: getVariableValue(variables, "typeface", "display") || "Roboto",
              },
            }}
            updateComponentStyle={(id, style) =>
              handleTypefaceChange(id, "display", style)
            }
          />
          <Typography
            showColors={false}
            showFontSize={false}
            caption={<div className="pb-3">Body & Labels</div>}
            hideLabel
            settings={{
              id: "typeface",
              properties: {
                fontFamily: getVariableValue(variables, "typeface", "body") || "Roboto",
              },
            }}
            updateComponentStyle={(id, style) =>
              handleTypefaceChange(id, "body", style)
            }
          />
        </div>
      </SectionWrapper>

      {/* Default Spacing */}
      <SectionWrapper
        label="Spacing"
        isExpanded={false}
        className="flex flex-col gap-4"
      >
        <TabsComponent
          tabs={[
            { label: "xs", value: "xs" },
            { label: "sm", value: "sm" },
            { label: "md", value: "md" },
            { label: "lg", value: "lg" },
            { label: "xl", value: "xl" },
            { label: "xxl", value: "xxl" },
          ]}
          activeTab={spacingTab}
          setActiveTab={setSpacingTab}
          actionSection={false}
          className="p-0 transform scale-95"
          type={TabTypes.BUTTON}
        />
        <ButtonSliderGroup
          onChange={(value) =>
            handleSpacingChange("spacing", spacingTab, convertToRem(value))
          }
          text={`Spacing`}
          button1={{ icon: <Minus />, value: "UP" }}
          button2={{ icon: <Plus />, value: "DOWN" }}
          minValue={0}
          maxValue={200}
          value={convertFromRem(
            getVariableValue(variables, "spacing", spacingTab) || "1rem"
          )}
        />
      </SectionWrapper>

      {/* Elevation & Shadows */}
      {/* <SectionWrapper
        label="Elevation & Shadows"
        isExpanded={false}
        className="flex flex-col gap-4"
      >
        <TabsComponent
          tabs={[
            { label: "Level 0", value: "level0" },
            { label: "Level 1", value: "level1" },
            { label: "Level 2", value: "level2" },
            { label: "Level 3", value: "level3" },
            { label: "Level 4", value: "level4" },
            { label: "Level 5", value: "level5" },
          ]}
          activeTab={elevationTab}
          setActiveTab={setElevationTab}
          actionSection={false}
          className="p-0 transform scale-95"
          type={TabTypes.BUTTON}
        />
        <Shadow
          onChange={console.log}
          settings={{
            id: "shadow",
            properties: {
              shadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
            },
          }}
        />
      </SectionWrapper> */}

      {/* Layout (containerMaxWidth) */}
      <SectionWrapper
        label="Layout"
        isExpanded={false}
        className="flex flex-col gap-4"
      >
        <TabsComponent
          tabs={[
            { label: "xs", value: "xs" },
            { label: "sm", value: "sm" },
            { label: "md", value: "md" },
            { label: "lg", value: "lg" },
            { label: "xl", value: "xl" },
            { label: "xxl", value: "xxl" },
          ]}
          activeTab={layoutTab}
          setActiveTab={setLayoutTab}
          actionSection={false}
          className="p-0 transform scale-95"
          type={TabTypes.BUTTON}
        />
        <Width
          widthLabel="Max Width"
          settings={{
            id: "layout",
            properties: {
              width: convertFromRem(getVariableValue(variables, "layout", layoutTab) || "100%"),
            },
          }}
          updateComponentStyle={(id, style) =>
            handleWidthChange(id, layoutTab, convertToRem(style?.width) || "100%")
          }
        />
      </SectionWrapper>
    </>
  );
};
